import {Component, OnInit} from '@angular/core';
import { AuthBridgeAuthenticate } from './models/auth-bridge-authenticate.model';
import { AuthBridgeAuthenticateResult } from './models/auth-bridge-authenticate-result.model';
import { AuthBridgeSuccessService } from './auth-bridge-success.service';

@Component({
  selector: 'app-auth-bridge-success',
  standalone: true,
  templateUrl: './auth-bridge-success.component.html'
})
export class AuthBridgeSuccessComponent implements OnInit {

  public isLoading:boolean = false;
  public error: boolean = false;
  public message: string;
  public result: AuthBridgeAuthenticateResult;

  constructor(private authService: AuthBridgeSuccessService) {
  }

  async ngOnInit(): Promise<void> {
      this.isLoading = true;
      const state: string = localStorage.getItem('state');
      const token: string = localStorage.getItem('access_token');
      this.message = state + ' - ' + token;

      const authBridgeData: AuthBridgeAuthenticate = { state: state };

      this.result = await this.authService.AuthenticateBridge(authBridgeData);

      if (this.result.success)
      {
        window.location.href = 'https://api.whatsapp.com/send/?phone=555140208205&text&type=phone_number&app_absent=0';
      }
      else
      {

        this.isLoading = false;
        this.error = true;
        this.message = "Ocorreu um erro ao autenticar. Volte ao Whatsapp e tente novamente o acesso.";
      }

  }
}
